export default __webpack_public_path__ + "static/media/charm-4.a07b1eed.png";